import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';

export const getCurrentCoordinateDirection = createSelector(
  (state: RootState) => state.editor.coordinateSystem,
  (state: RootState) => state.editor.coordinateUpDirection,
  (coordinateSystem, coordinateUpDirection) => {
    if (coordinateSystem === 'local') {
      return coordinateUpDirection;
    }
    return { x: 0, y: 1 };
  },
);
